<bn-loading-overlay></bn-loading-overlay>

<h5>Tarefas para limites de contratação</h5>

<div class="container">
  <div ngbAccordion>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="title2">Consulta de limite de contratação de beneficiário</button>
      </h2>

      <div ngbAccordionCollapse>
			<div ngbAccordionBody>
      <ng-template>
        <div class="row">

          <div class="col-md-3">
            <label for="alterarIdSh">CPF/CNPJ do beneficiário:</label> 
            <input type="text" id="cpfOuCnpjBeneficiario" class="form-control" [(ngModel)]="cpfOuCnpjBeneficiario">
          </div>

          <div class="col-md-3">
            <label for="alterarIdSh">CNPJ do agente financeiro:</label>
            <input type="text" id="cnpjAgenteFinanceiro" class="form-control" [(ngModel)]="cnpjAgenteFinanceiro">
          </div>

          <div class="col-md-3">
            <label for="alterarIdSh">Numero da tranche:</label>
            <input type="text" id="numeroTranche" class="form-control" [(ngModel)]="numeroTranche">
          </div>
        </div>
        <div class="row">
          <div class="submit col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="buscarLimiteBeneficiarioFg2()">Consultar</button>
          </div>
        </div>
      </ng-template>
    </div>
    </div>
    </div>

    <div ngbAccordionItem>
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton class="title2">Consulta de limite de contratação de beneficiário no FGI Tradicional (sistema legado)</button>
        </h2>

      <div ngbAccordionCollapse>
			<div ngbAccordionBody>
      <ng-template ngbPanelContent>
        <div class="row">
          <div class="col-md-3">
            <label for="alterarIdSh">CPF/CNPJ do beneficiário:</label> 
            <input type="text" id="cpfOuCnpjBeneficiario" class="form-control" [(ngModel)]="cpfOuCnpjBeneficiario">
          </div>

          <div class="col-md-3">
            <label for="alterarIdSh">CNPJ do agente financeiro:</label>
            <input type="text" id="cnpjAgenteFinanceiro" class="form-control" [(ngModel)]="cnpjAgenteFinanceiro">
          </div>
        </div>
        <div class="row">
          <div class="submit col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="buscarLimiteBeneficiarioFgiTradicional()">Consultar</button>
          </div>
        </div>
      </ng-template>
    </div>
    </div>
    </div>


    <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="title2">Cálculo de exposição</button>
    </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="row">
              <div class="col-md-3">
                <label for="idOperacaoGarantida">Id. operação garantida:</label> 
                <input type="text" id="idOperacaoGarantida" class="form-control" [(ngModel)]="idOperacaoGarantida">
              </div>
            </div>
            <div class="row">
              <div class="submit col-auto">
                <button type="button" class="btn btn-success no-margin" (click)="calcularLimiteExposicao()">Calcular</button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

  </div>
</div> 